<template>
  <div id="app">
    <notifications group="apolo" />
    <Navbar2 v-if="!iframe" :logueado="logueado"/>
    <div class="bg-white-100 text-2xl py-4 px-190 text-center items-center">
    <nav>
    </nav>
    <div v-if="showTimer" class="timer-global">
      {{ formatoTiempo }}
    </div>
    <router-view 
      @login_realizado="checkLogin" 
      @eventBoletosIda="boletosIda" 
      @eventBoletosVuelta="boletosVuelta" 
      :boletos_ida="boletos_ida"
      :boletos_vuelta="boletos_vuelta"
       />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Navbar2 from '@/components/Nav.vue'
import { EventTimer } from "@/eventTimer";

export default {
  
  name: 'HomeView',
  
  components: {
    Navbar2,
  },
  data: () => ({
    logueado: false,
    iframe: false,
    boletos_ida: null,
    boletos_vuelta: null,
    cantidad_minutos_compra_en_linea: null,
    intervalId: null,
    showTimer: false,
    timerListener: null
  }),
  mounted(){
    this.iframe = this.inIframe();
    this.getOpciones();
    this.timerListener = () => {
      this.iniciarTimer();
    };
    EventTimer.$on("iniciarTimerGlobal", this.timerListener);
  },  
  beforeDestroy() {
    clearInterval(this.intervalId);
    if (this.timerListener) {
      EventTimer.$off("iniciarTimerGlobal", this.timerListener);
    }
  },
  computed: {
    formatoTiempo() {
      const m = Math.floor(this.cantidad_minutos_compra_en_linea / 60);
      const s = this.cantidad_minutos_compra_en_linea % 60;
      return `${m}:${s < 10 ? "0" + s : s}`;
    }
  },
  methods: {
    async getOpciones(){
      const options = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json"
        },
      };
      axios.get(`/opciones`, options).then((response) => {
        const opciones = response.data.data;
        const item = opciones.find(
          (op) => op.attributes.clave === "cantidad_minutos_compra_en_linea"
        );
        const valor = item ? parseInt(item.attributes.valor) : null;
        this.cantidad_minutos_compra_en_linea = valor * 60;
      });
    },
    async iniciarTimer() {
      if (!this.cantidad_minutos_compra_en_linea) {
        await this.getOpciones();
      }
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.showTimer = true;

      const inicio = Date.now();
      const duracion = this.cantidad_minutos_compra_en_linea * 1000;
      
      this.intervalId = setInterval(() => {
        const ahora = Date.now();
        const diferencia = Math.floor((duracion - (ahora - inicio)) / 1000);

        if (diferencia > 0) {
          this.cantidad_minutos_compra_en_linea = diferencia;
        } else {
          this.cantidad_minutos_compra_en_linea = 0;
          clearInterval(this.intervalId);
          this.onTimerFinish();
        }
      }, 200);
    },
    onTimerFinish() {
      this.showTimer = false;
      this.$notify({
        group: "apolo",
        type: "error",
        title: "Notificación Platinum Line",
        text: "El tiempo para proceso de compra ha expirado",
        duration: -1
      });
      this.cantidad_minutos_compra_en_linea = null;
      this.intervalId = null;
      const corrida = localStorage.getItem("corrida_ida_id");
      const subcorrida = localStorage.getItem("subcorrida_id");
      const token = localStorage.getItem("token_id");
      this.freeSeats(corrida, subcorrida, token);
      const corrida_vuelta = localStorage.getItem("corrida_vuelta_id");
      const subcorrida_vuelta = localStorage.getItem("subcorrida_vuelta_id");
      if(corrida_vuelta){
        this.freeSeats(corrida_vuelta, subcorrida_vuelta, token);
      }
      this.getOpciones();
      this.$router.push("/");
    },
    async freeSeats(corrida, subcorrida, token){
      let json = {
        data: {
          attributes: {
            corrida_id: corrida,
            subcorrida_id: subcorrida,
            token_id: token
          }
        },
      };
      let config = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      let me = this;
      axios.post("/liberarAsientos", json, config).then(function (response) {
        console.log(response)
      }).catch(function (error) {
        if(error.response.data.errors){
            me.$notify({
              group: "apolo",
              type: "error",
              title: "Notificación Platinum Line",
              text: error.response.data.errors[0].detail,
              duration: -1
            });
        }else{
          me.$notify({
            group: "apolo",
            type: "error",
            title: "Notificación Platinum Line",
            text: error.response.data.message,
            duration: -1
          });
        }
      });
    },
    checkLogin(data) {
      this.logueado = data;
    },
    boletosIda(data){
      this.boletos_ida = data;
    },
    boletosVuelta(data){
      this.boletos_vuelta = data;
    },
    inIframe () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
}
}

</script>

<style lang="less">
.timer-global {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: #822c30;
  color: white;
  padding: 10px 15px;
  border-radius: 8px;
  font-weight: bold;
  z-index: 9999;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 0px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #f9f9f9;
    }
  }
}
</style>



